/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../../../services/AxiosInstance';
import { getDuration } from '../../../../Functions/dates';
import { userContext } from '../../../../contextProvider/Authentication';
import { Modal } from 'react-bootstrap';

function Jobsappliedjob() {

	const { user } = useContext(userContext);

	const [jobs, setJobs] = useState([]);
	const [show, setShow] = useState(false);
	const [interview, setInterview] = useState({});

	useEffect(() => {
		getData();
	}, [user]);

	const getData = (page = 1) => {
		axiosInstance(`can-applyjob/?page=${page}&user=${user?.id}`, { method: "GET" })
			.then(res => setJobs(res?.data))
	}

	return (
		<>
			{/* Interview Schedule View Modal */}
			<Modal show={show} onHide={setShow} className="modal fade modal-bx-info">
				<div className="modal-dialog my-0" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<h5 className="modal-title">{interview?.workflow_detials?.name}</h5>
							<button type="button" className="close" onClick={() => setShow(false)}>
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div className="modal-body">
							<ul>
								<li><strong>Job Title :</strong><p> {interview?.job_name} </p></li>
								<li><strong>Date of Interview :</strong><p>{interview?.interview_time}</p></li>
								<li><strong>Interview Wrokflows :</strong>
									{
										interview?.workflow_detials?.workflow &&
										<p>{Object.keys(interview?.workflow_detials?.workflow).map(function (key) { return <> <span style={{ textTransform: "capitalize" }}>{key}</span> : {interview?.workflow_detials?.workflow[key]}, &nbsp; <br /> </> })}</p>
									}
								</li>
							</ul>
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-secondary" onClick={() => setShow(false)}>Close</button>
						</div>
					</div>
				</div>
			</Modal>
			{/* Interview Schedule View Modal */}

			<div className="job-bx-title  clearfix">
				<h5 className="font-weight-700 pull-left text-uppercase">{jobs?.pagination?.totalEntries} Jobs Found</h5>
				{/* <div className="float-right">
											<span className="select-title">Filter by freshness</span>
											<select className="custom-btn">
												<option>Last 2 Months</option>
												<option>Last Months</option>
												<option>Last Weeks</option>
												<option>Last 3 Days</option>
											</select>
										</div> */}
			</div>
			<ul className="post-job-bx browse-job">
				{jobs?.results?.length > 0 ? jobs?.results?.map((item, index) => {
					return (
						<li key={index}>
							<div className="post-bx">
								<div className="job-post-info m-a0">
									<h4><Link to={`/job-detail/${item.job}`}>{item?.job_name}</Link></h4>
									<ul>
										<li><Link to={"#"}>{item?.company}</Link></li>
										<li><i className="fa fa-map-marker"></i> {item?.city}, {item?.country}</li>
										<li><i className="fa fa-money"></i> {item?.salary} </li>
									</ul>
									<div className="job-time m-t15 m-b10">
										{
											item?.categories?.length > 0 &&
											item?.categories.map(res =>
												<Link to={'#'} className="mr-1"><span>{res}</span></Link>
											)
										}
									</div>
									<div className="posted-info clearfix">
										<p className="m-tb0 text-primary float-left"><span className="text-black m-r10">Posted:</span> {getDuration(item.created_on)} ago</p>
										{/* <Link
																	to={"#"}
																	className="site-button button-sm float-right"
																	title={`Interview Scheduled on ${item.interview_time}`}
																> Status: {item.status}
																</Link> */}
										{
											item?.status === 'Interview Scheduled' ?
												<Link to="#" onClick={() => { setShow(true); setInterview(item) }} className="site-button button-sm float-right"> Status: {item.status} </Link>
												:
												<Link to="#" className="site-button button-sm float-right"> Status: {item.status} </Link>
										}
									</div>
								</div>
							</div>
						</li>
					)
				})
					:
					<div className="alert alert-danger">
						<h5 className="text-center">No Data Found</h5>
					</div>
				}
			</ul>
			<div className="pagination-bx m-t30">
				<div className="d-flex">
					<button
						className="site-button button-sm mr-auto"
						disabled={jobs?.pagination?.previousPage ? false : true}
						onClick={() => getData(jobs?.pagination?.previousPage)}
						style={{ backgroundColor: jobs?.pagination?.previousPage ? "#1d46f5" : "#8b99d5", cursor: jobs?.pagination?.previousPage ? "pointer" : "not-allowed" }}
					>
						<i className="ti-arrow-left"></i> Prev
					</button>
					<button
						className="site-button button-sm"
						disabled={jobs?.pagination?.nextPage ? false : true}
						onClick={() => getData(jobs?.pagination?.nextPage)}
						style={{ backgroundColor: jobs?.pagination?.nextPage ? "#1d46f5" : "#8b99d5", cursor: jobs?.pagination?.nextPage ? "pointer" : "not-allowed" }}
					>
						Next <i className="ti-arrow-right"></i>
					</button>
				</div>
			</div>
		</>
	)
}
export default Jobsappliedjob; 